<template>
  <el-form
    ref="form"
    :model="organization"
    :rules="rules"
    @submit.native.prevent
  >
    <loader-wrapper :loading="loading">
      <el-row :gutter="24">
        <el-col :span="24">
          <p>
            Для начала работы введите ИНН вашего ИП/ООО. Нажмите кнопку
            "Проверить ИНН
          </p>
        </el-col>
      </el-row>
      <el-row :gutter="24">
        <el-col :span="24">
          <p>ИНН*</p>
        </el-col>

        <el-col :span="12">
          <el-input
            v-model="organization.inn"
            size="medium"
            :disabled="detected_inn"
            placeholder="Введите ИНН"
          />
        </el-col>
        <el-col :span="12">
          <el-button
            size="medium"
            :disabled="detected_inn"
            type="primary"
            @click="checkINN"
          >
            Проверить ИНН
          </el-button>
        </el-col>
      </el-row>
      <div style="padding-top: 10px">
        <el-alert
          v-show="notes"
          :title="notes"
          :type="detected_inn ? 'success' : 'error'"
          show-icon
          :closable="false"
          effect="dark"
        />
      </div>
    </loader-wrapper>
    <el-collapse-transition>
      <div v-if="detected_inn">
        <div style="padding-top: 10px">
          <h3 style="text-align: center">Информация по ИНН найдена верно?</h3>
          <div style="text-align: center">
            <el-button
              style="margin: 10px"
              type="success"
              @click="addOrganization"
            >
              Да, добавить организацию
            </el-button>
            <el-button style="margin: 10px" type="warning" @click="cleanForm">
              Нет, изменить ИНН
            </el-button>
          </div>
        </div>
      </div>
    </el-collapse-transition>
  </el-form>
</template>

<script>
import { GET_PROFILE } from '@/store/actions/userprofile'
import { RepositoryFactory } from '@/api/RepositoryFactory'
import { validateRs } from '@/helpers/validate-req'
import LoaderWrapper from '@/components/Shared/LoaderWrapper'

const Organization = RepositoryFactory.get('userOrganizations')
const Check = RepositoryFactory.get('check')

export default {
  name: 'CheckOrganization',
  components: { LoaderWrapper },
  props: {
    userId: {
      type: Number,
      default: 0,
    },
    close: {
      type: Function,
      default: () => {},
    },
  },
  data() {
    return {
      errorRs: {
        code: 0,
        message: '',
      },
      organization: {
        inn: '',
        organization_id: 0,
        is_approve: 0,
        bik: '',
        name_bank: '',
        core_account: '',
        rs: '',
      },
      detected_inn: false,
      notes: '',
      rules: {
        bik: { required: true, message: 'Укажите БИК банка', trigger: 'blur' },
        name_bank: {
          required: true,
          message: 'Укажите название банка',
          trigger: 'blur',
        },
        core_account: {
          required: true,
          message: 'Укажите коресподентский счет',
          trigger: 'blur',
        },
        checking_account: {
          required: true,
          message: 'Укажите номер счета',
          trigger: 'blur',
        },
      },
      loading: false,
    }
  },
  computed: {
    needAdditional() {
      return this.canAction('additionalCompany')
    },
  },
  methods: {
    checkRs() {
      this.organization.checking_account =
        this.organization.checking_account.replace(/\s/g, '')
      validateRs(
        this.organization.checking_account,
        this.organization.bik,
        this.errorRs,
      )
    },
    checkINN() {
      this.loading = true
      Check.inn(this.organization.inn)
        .then(res => {
          this.loading = false

          if (res.data) {
            const { short_name, id } = res.data

            this.detected_inn = true
            this.organization.organization_id = id
            this.notes = short_name
          } else {
            this.notes = 'Организация не найдена'
          }
        })
        .catch(() => (this.loading = false))
    },
    checkBik() {
      Check.bik(this.organization.bik).then(response => {
        if (response.data && !response.data.error) {
          this.organization.name_bank = response.data.name
            .split('&quot;')
            .join("'")
          this.organization.core_account = response.data.ks
        } else {
          this.organization.name_bank = 'Банк не найден'
        }
      })
    },
    cleanForm() {
      this.organization = {
        inn: '',
        organization_id: 0,
        is_approve: 0,
        bik: '',
        name_bank: '',
        core_account: '',
        rs: '',
      }
      this.detected_inn = false
      this.notes = ''
    },
    addOrganization() {
      const data = this.organization

      data.user_id = this.userId
      Organization.postItem(data)
        .then(res => {
          if (res.data) {
            this.$store.dispatch(`userProfile/${GET_PROFILE}`)
            this.$router.push({
              path: '/organization-edit?id=' + res.data.id,
            })
          }
        })
        .catch(() => this.close())
    },
  },
}
</script>

<style lang="sass">
.empty-p
  height: 18px
.inn-buttons-block
  display: flex
  justify-content: flex-end
</style>
